import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files directly for synchronous initialization
import enTranslations from './locales/en.json'
import frTranslations from './locales/fr.json'

// Language detection options
const languageDetectorOptions = {
  // Order of language detection
  order: [
    'navigator', // Browser language
    'localStorage', // Stored preference
    'sessionStorage', // Session preference
    'htmlTag', // HTML lang attribute
    'subdomain', // URL subdomain
    'querystring', // URL query parameter
  ],
  
  // Cache user language preference
  caches: ['localStorage'],
  
  // Don't cache in session storage
  excludeCacheFor: ['cimode'],
  
  // Fallback language
  fallbackLng: 'en',
  
  // Check for supported languages only
  checkWhitelist: true,
}

// Available languages
export const supportedLanguages = {
  en: 'English',
  fr: 'Français',
} as const

export type SupportedLanguage = keyof typeof supportedLanguages

// Initialize i18next synchronously
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Language resources
    resources: {
      en: {
        translation: enTranslations,
      },
      fr: {
        translation: frTranslations,
      },
    },
    
    // Fallback language
    fallbackLng: 'en',
    
    // Supported languages
    supportedLngs: Object.keys(supportedLanguages),
    
    // Debug mode (disable in production)
    debug: import.meta.env.DEV,
    
    // Language detection options
    detection: languageDetectorOptions,
    
    // Interpolation options
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // React options
    react: {
      useSuspense: false, // Keep suspense disabled for better error handling
    },
    
    // Namespace options
    defaultNS: 'translation',
    ns: ['translation'],
    
    // Key separator for nested translations
    keySeparator: '.',
    
    // Plural separator
    pluralSeparator: '_',
    
    // Context separator
    contextSeparator: '_',
  })

export default i18n 